module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("now were dominated by uncertainty – what had happened to Eric? Would they ever see him again?")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("In April 1945, British troops under Field Marshal Montgomery were sent at speed to the south-west Baltic in an urgent attempt to stem the Russian advance along the Baltic coast into northwest Europe. Churchill and Roosevelt had agreed that it was necessary, at all cost, to stop the Bolsheviks from reaching the North Sea and the coast of the Atlantic. As a consequence, Montgomery would bypass the occupied western Netherlands, Holland, although the people there were dying of hunger during what was the coldest winter in living memory. It was a South African, Jan Smuts, who, amongst the Allied generals, pleaded for alternatives to be found. So it was decided that the 5th Canadian Armoured Division would be sent to secure the port of Delfzijl, twenty-five kilometres northeast of the city of Groningen, so that supplies could be shipped in to build up stock for the relief of the suffering population of Holland. To get to Delfzijl, the city of Groningen would need to be liberated, which became the task of the 2nd Canadian Division. The Canadians would be supported by armed fighters from the Resistance, whilst the "), _c('em', [_vm._v("Ordedienst")]), _vm._v(" would be ready to take control of the liberated parts of the city. The task force would be supported by fifty Sherman tanks and a smaller number of the lighter Stuart tanks.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The battle for the control of Groningen lasted five days. For the Canadians, it was the most intense urban warfare they faced in WWII. The city had about 125,000 inhabitants, but in addition there were some 25,000 refugees who had fled north to escape the fighting in the most southern Dutch province, Limburg. I saw many of them because I had to help in the bakery with the preparation of many thousands of sandwiches and bread buns, and their distribution to the refugees. They were resting on straw in the city’s concert hall and in other public buildings. I felt a great pity for the exhausted people. They lay still but with their eyes open, staring in terror at their memories.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Seeing that the city was overcrowded, the Allies decided that attacks from the air and the use of heavy artillery would not be possible. They would have to go in on foot. The assault would be a job for the Royal Regiment of Canada, the Royal Hamilton Light Infantry, the Black Watch, and the Calgary Highland- ers. On the Francophone side, there was Le Regiment de Maisonneuve.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The combat began on 14 April 1945. The enemy had blown up or heavily damaged eight of the bridges in the city. The remaining bridges were mostly bascule bridges, which had been pulled up. Around the periphery of the city, low-lying land had been inundated. More than 7,500 troops under the command of Major-General Karl Böttger defended the city. Their capitulation was not conceivable because of the presence of many fanatical supporters of the regime. They were members of the armed wing of the Nazi party, the SS"), _c('em', [_vm._v(".")]), _vm._v(" On the market square, they had barricaded the north and east sides. From")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2f8438e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0037.vue
// module id = 171
// module chunks = 0